import { DEFAULT_EXPIRE_TIME_1HR, ONE_SEC_IN_MS } from './constants';
var getExpireIn = function getExpireIn(ttl) {
  var date = new Date();
  if (ttl && typeof ttl === 'number') {
    return date.getTime() + ttl * ONE_SEC_IN_MS;
  }
  return date.getTime() + DEFAULT_EXPIRE_TIME_1HR * ONE_SEC_IN_MS;
};
export default getExpireIn;